import { SecuredClient } from '../../../Core/Api/SecuredClient';

export interface BotQueueItem {
    id?: string;
    botUserId?: string;
    gameId?: string;
    isProcessing?: boolean;
    score?: number;
    creationDate?: string;
    processedAt?: string;
    lastError?: string;
    errors?: number;
}

export interface QueueSummary {
    totalInQueue?: number;
    currentlyProcessing?: number;
    failedItems?: number;
}

export interface QueueResponse {
    items?: BotQueueItem[];
    count?: number;
}

export class BotQueueHandler {
    async getBotQueueItems(page: number, pageSize: number, showProcessedOnly?: boolean): Promise<any> {
        return this.fetchBotQueueStatus(page, pageSize, showProcessedOnly);
    }

    async getBotQueueSummary(): Promise<any> {
        return this.fetchBotQueueStatus(1, 1);
    }

    private async fetchBotQueueStatus(page: number, pageSize: number, showProcessedOnly?: boolean): Promise<any> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;
        const params = new URLSearchParams();
        if (showProcessedOnly !== undefined) params.append('ShowProcessedOnly', showProcessedOnly.toString());
        params.append('PageNumber', page.toString());
        params.append('AmountPerPage', pageSize.toString());
        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/GetBotQueueStatus?${params.toString()}`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }
}
